import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "versions" */ "../views/Home.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/versions",
    name: "Versions",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "versions" */ "../views/Versions.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: () => import(/* webpackChunkName: "jobs" */ "../views/Jobs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/logs",
    name: "Logs",
    component: () => import(/* webpackChunkName: "logs" */ "../views/Logs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customers",
    name: "Customers",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "customers" */ "../views/Customers.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customers/:customerId",
    name: "Customer",
    props: true,
    component: () =>
      import(/* webpackChunkName: "customer" */ "../views/Customer.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "customers" */ "../views/Login.vue")
  },
  {
    path: "/billing",
    name: "Billing",
    component: () =>
      import(/* webpackChunkName: "biling" */ "../views/Billing.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "*",
    component: () =>
      import(/* webpackChunkName: "customers" */ "../views/NotFound.vue"),
    meta: { requiresAuth: true }
  }
];

const router = new VueRouter({
  mode: "history",
  routes
});

router.beforeEach((to, from, next) => {
  var session = JSON.parse(localStorage.getItem("session"));
  const loggedIn = !!(session != null && session.id);
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
